import { AnalyticsEvents, mixpanel } from "common/analytics";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AddFeedEventDialog,
  AddFeedPurchaseEventDialog,
  AddFertilizerEventDialog,
  AddFieldPreparationEventDialog,
  AddReseedEventDialog,
  AddYieldEventDialog,
} from "./AddNewEventDialogs";

export function useAddNewEventDialogs() {
  const navigate = useNavigate();

  // Dialog states for each event type
  const [reseedDialogOpen, setReseedDialogOpen] = useState(false);
  const [feedDialogOpen, setFeedDialogOpen] = useState(false);
  const [feedPurchaseDialogOpen, setFeedPurchaseDialogOpen] = useState(false);
  const [yieldDialogOpen, setYieldDialogOpen] = useState(false);
  const [fertilizerDialogOpen, setFertilizerDialogOpen] = useState(false);
  const [fieldPreparationDialogOpen, setFieldPreparationDialogOpen] =
    useState(false);

  const handleEventTypeClick = (eventType: string) => {
    switch (eventType) {
      case "reseed":
        mixpanel.track(AnalyticsEvents.BULK_RESEED_FORM_OPENED);
        setReseedDialogOpen(true);
        break;
      case "feed":
        setFeedDialogOpen(true);
        break;
      case "feedPurchase":
        setFeedPurchaseDialogOpen(true);
        break;
      case "yield":
        setYieldDialogOpen(true);
        break;
      case "fertilizer":
        setFertilizerDialogOpen(true);
        break;
      case "fieldPreparation":
        setFieldPreparationDialogOpen(true);
        break;
      case "cover":
        // Cover uses routes, so navigate to it
        mixpanel.track(AnalyticsEvents.BULK_COVER_INPUT_OPENED);
        navigate("/add-covers/enter-time");
        break;
    }
  };

  // Check if any dialog is currently open
  const isAnyDialogOpen =
    reseedDialogOpen ||
    feedDialogOpen ||
    feedPurchaseDialogOpen ||
    yieldDialogOpen ||
    fertilizerDialogOpen ||
    fieldPreparationDialogOpen;

  const dialogs = (
    <>
      <AddReseedEventDialog
        dialogOpen={reseedDialogOpen}
        setDialogOpen={setReseedDialogOpen}
      />
      <AddFeedEventDialog
        dialogOpen={feedDialogOpen}
        setDialogOpen={setFeedDialogOpen}
      />
      <AddFeedPurchaseEventDialog
        dialogOpen={feedPurchaseDialogOpen}
        setDialogOpen={setFeedPurchaseDialogOpen}
      />
      <AddYieldEventDialog
        dialogOpen={yieldDialogOpen}
        setDialogOpen={setYieldDialogOpen}
      />
      <AddFertilizerEventDialog
        dialogOpen={fertilizerDialogOpen}
        setDialogOpen={setFertilizerDialogOpen}
      />
      <AddFieldPreparationEventDialog
        dialogOpen={fieldPreparationDialogOpen}
        setDialogOpen={setFieldPreparationDialogOpen}
      />
    </>
  );

  return {
    handleEventTypeClick,
    dialogs,
    isAnyDialogOpen,
  };
}
